export const linkActions = {
    navigate: 'navigate',
    cmp: 'cmp',
    link: 'link',
} as const;

export type TFooterLink = {
    link: string;
    action: keyof typeof linkActions;
    redirectLink?: string;
    title: string;
}

export const footerLinks = [
    {
        link: 'impressum',
        action: linkActions.navigate,
        title: 'Impressum',
    },
    {
        link: 'disclaimer',
        action: linkActions.navigate,
        title: 'Disclaimer',
    },
    {
        link: 'datenschutz',
        action: linkActions.navigate,
        title: 'Datenschutz',

    },
    {
        link: 'cookie-einstellungen',
        action: linkActions.cmp,
        title: 'Cookie-Einstellungen',
    },
    {
        link: 'kontakt',
        action: linkActions.navigate,
        title: 'Kontakt',
    },
    {
        link: 'zugang entsperren',
        action: linkActions.link,
        redirectLink: 'https://mmscache.deka.de/Deka_Connect_Zugang_Daten_aendern.pdf',
        title: 'Zugang entsperren',
    },
    {
        link: 'bfsg-explanation',
        action: linkActions.navigate,
        title: 'Erklärung zur Barrierefreiheit',
    },
];
